module.exports = __webpack_public_path__ + "images/home_icon_null_data.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_icon_null_data.png
// module id = 817
// module chunks = 124